<div class="bulk-delete-popup" [style.width]="POPUP_DEFAULTS.WIDTH">
  <h1 class="bulk-delete-popup-title">{{ 'BulkDeletePopup.Title' | translate }}</h1>
  <p class="bulk-delete-popup-body" style="white-space: pre-line">
    {{ 'BulkDeletePopup.Body' | translate }}
  </p>

  <div class="flex justify-end gap-2 mt-4">
    <tar-icon-button
      type="secondary"
      [label]="'BulkDeletePopup.GoToKnowledgeBase' | translate"
      (click)="onGoToKnowledgeBase()"
    />
    <tar-icon-button
      type="primary"
      icon=""
      [label]="'BulkDeletePopup.Understood' | translate"
      (click)="onUnderstood()"
    />
  </div>
</div>
